import { Link } from 'react-router-dom';

import { Gate } from '../../../global/contexts/auth/auth';
import { IconChart, IconEdit } from '../../../common/icons';
import { useSemen } from '../contexts/semen';

import '../../../common/styles/catalog.css';

const STATUS_LABEL = { 2: 'Activo', 1: 'Inactivo', 0: 'Eliminado' };
const ORIGIN_LABEL = { national: 'Nacional', imported: 'Importado' };

function Field({ label, value }) {
    return (
        <div className="cat-detail__field">
            <span className="cat-detail__field-label">{label}</span>
            <span className="cat-detail__field-value">
                {value || <span className="cat-detail__empty">—</span>}
            </span>
        </div>
    );
}

function sireText(s) {
    if (s.sire_name) return s.sire_register ? `${s.sire_name} (${s.sire_register})` : s.sire_name;
    if (s.sire_register) return s.sire_register;
    if (s.sire_animal_id != null) return `Toro #${s.sire_animal_id}`;
    return null;
}

export default function SemenDetail({ semenId }) {
    const { data: semen, isLoading, error } = useSemen(semenId);

    if (isLoading) return <div className="cat-detail__state">Cargando semen…</div>;
    if (error || !semen) return <div className="cat-detail__state">Semen no encontrado.</div>;

    return (
        <div className="cat-detail">
            <header className="cat-detail__header">
                <div>
                    <Link to="/admin/semen" className="cat-detail__back">Semen</Link>
                    <div className="cat-detail__title-row">
                        <h1 className="cat-detail__title">{semen.code}</h1>
                        <span className={`cat-badge cat-badge--${semen.status}`}>{STATUS_LABEL[semen.status] || '—'}</span>
                    </div>
                </div>
                <div className="cat-detail__actions">
                    <Gate domain="kpis" action="read">
                        <Link to={`/admin/semen/${semen.id}/stats`} className="cat-detail__edit">
                            <IconChart /><span>Estadísticas</span>
                        </Link>
                    </Gate>
                    <Gate domain="semen" action="write">
                        <Link to={`/admin/semen/${semen.id}/edit`} className="cat-detail__edit">
                            <IconEdit /><span>Editar</span>
                        </Link>
                    </Gate>
                </div>
            </header>

            <section className="cat-detail__card">
                <h2 className="cat-detail__section-title">Información</h2>
                <div className="cat-detail__grid">
                    <Field label="Nombre comercial" value={semen.name} />
                    <Field label="Raza" value={semen.race?.name} />
                    <Field label="Origen" value={ORIGIN_LABEL[semen.origin]} />
                    <Field label="Proveedor" value={semen.supplier} />
                    <Field label="Padre" value={sireText(semen)} />
                    <Field label="Estado" value={STATUS_LABEL[semen.status]} />
                </div>
            </section>
        </div>
    );
}
